// src/components/shared/AuthAlert.js
import React from 'react';

const AuthAlert = ({ message, variant = 'danger' }) => {
  if (!message) return null;
  return <div className={`alert mt-3 alert-${variant}`}>{message}</div>;
};

export default AuthAlert;
